export default function Clock_Hands() {
  return (
    <div>
      <h1>Clock_Hands Component</h1>
    </div>
  );
}
